import { DetailAction } from '../../detail/actions/DetailAction';
import { Utils } from '@lightningjs/sdk';
import { SelectOptionDialog } from '../../../components/option/SelectOptionDialog';
import { Backend } from '../../../api/Backend';
import { CmsFilterCallback, CmsFilterData } from './CmsFilterTypes';
import { OptionData } from '../../../components/option/OptionData';

export class RatingCmsFilterAction extends DetailAction {
  private filter: CmsFilterData;
  private _callback: CmsFilterCallback;

  constructor(backend: Backend, filter: CmsFilterData, callback: CmsFilterCallback) {
    super(backend);
    this.filter = filter;
    this._callback = callback;
  }

  override doAction() {
    const options = [
      {
        icon: Utils.asset('images/ratings/rating-1-star.png'),
        focusIcon: Utils.asset('images/ratings/rating-1-star-sel.png'),
        value: [0, 25],
      },
      {
        icon: Utils.asset('images/ratings/rating-2-star.png'),
        focusIcon: Utils.asset('images/ratings/rating-2-star-sel.png'),
        value: [26, 50],
      },
      {
        icon: Utils.asset('images/ratings/rating-3-star.png'),
        focusIcon: Utils.asset('images/ratings/rating-3-star-sel.png'),
        value: [51, 75],
      },
      {
        icon: Utils.asset('images/ratings/rating-4-star.png'),
        focusIcon: Utils.asset('images/ratings/rating-4-star-sel.png'),
        value: [76, 100],
      },
    ];
    this.owner?.fireAncestors('$openDialog', {
      type: SelectOptionDialog,
      params: {
        backend: this._backend,
        options: options,
        onSuccess: (val: OptionData) => {
          this.optionSelected(val);
        },
        onCancelled: this.hideOptions.bind(this),
      },
    });
  }

  optionSelected(option: OptionData) {
    this.filter.rating = option;
    this._callback(this.filter);
    this.hideOptions();
  }

  hideOptions() {
    this.owner?.fireAncestors('$closeDialog');
  }
}
